const translations = {
  title: 'Routines',
  title_routines: 'Routines',
  new_routines: 'New Routine',
  new: 'New Routine',
  modalTitle: 'New routine',
  modalTitle_edit: 'Editing routine',
  name: 'Name',
  nameRequired: 'Name*',
  folder: 'Folder',
  quantity: 'Quantity',
  activitiesRequired: 'Activities*',
  configureActivities: '+ Configure Activities',
  customizeRecurrence: 'Customize Recurrence*',
  repeatEvery: 'Repeat every',
  repeat: 'Repeat',
  startsAt: 'Starts at',
  endsAt: 'Ends',
  never: 'Never',
  on: 'On',
  'frequencyOptions.day': 'Day',
  'frequencyOptions.week': 'Week',
  'frequencyOptions.year': 'Year',
  mustHaveAtLeastOneActivity: 'Must have at least 1 activity',
  checkActivities: 'Check activities',
  cannotBeLessOrEqualToZero: 'Cannot be less than or equal to zero',
  startDateMustBeGreaterThanCurrent: 'Start date must be greater than current date.',
  endDateMustBeGreaterThanStart: 'End date must be greater than start date.'
}

export default translations
